import SearchScenarioId from '../store/schema/SearchScenarioId';
import { SubstrateSearchScenario } from 'owa-search-service';

export default function getSubstrateSearchScenarioBySearchScenarioId(
    scenarioId: SearchScenarioId
): SubstrateSearchScenario {
    switch (scenarioId) {
        case SearchScenarioId.Mail:
            return SubstrateSearchScenario.Mail;
        case SearchScenarioId.Calendar:
            return SubstrateSearchScenario.Calendar;
        case SearchScenarioId.FilesHub:
            return SubstrateSearchScenario.FilesHub;
        default:
            throw Error(
                `No corresponding SubstrateSearchScenario for given SearchScenarioId (${scenarioId}).`
            );
    }
}
